module.exports = __webpack_public_path__ + "static/fonts/Poppins-LightItalic.0613c48.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-LightItalic.ttf
// module id = 1027
// module chunks = 11